var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgA2ElectricalCircuit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 14v48h58V14H9zm54 44H16.3l18-18H63v18zm0-22H32.55L13 55.62V18h50v18z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/A2_Electrical_Circuit.154d75ac.svg";
export { SvgA2ElectricalCircuit as ReactComponent };